import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './par-region.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParRegionDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const parRegionEntity = useAppSelector(state => state.parRegion.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="parRegionDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.parRegion.detail.title">ParRegion</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{parRegionEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.parRegion.code">Code</Translate>
            </span>
          </dt>
          <dd>{parRegionEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.parRegion.name">Name</Translate>
            </span>
          </dt>
          <dd>{parRegionEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.parRegion.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{parRegionEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.parRegion.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{parRegionEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.parRegion.status">Status</Translate>
            </span>
          </dt>
          <dd>{parRegionEntity.status}</dd>
          <dt>
            <Translate contentKey="almobadaraMasterDataApp.parRegion.country">Country</Translate>
          </dt>
          <dd>{parRegionEntity.country ? parRegionEntity.country.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/par-region" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/par-region/${parRegionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParRegionDetail;
